import type { Context } from 'react'
import { createContext } from 'react'
import type { SetPositionStateType, SetPositionActionType } from 'storeContext/reducers/setPosition'
import type { DispatchFnType } from 'storeContext/types'

export type SetPositionThunkType = (dispatch: DispatchFnType) => Promise<void>
export type SetPositionDispatchType = (action: SetPositionActionType | SetPositionThunkType) => void

export interface SetPositionContextValueType {
  state: SetPositionStateType
  dispatch: SetPositionDispatchType
}

// Preserve the legacy raw-state default; consumers receive the provider's { state, dispatch }.
export const createSetPositionContext = (initialState: SetPositionStateType) =>
  createContext(initialState) as unknown as Context<SetPositionContextValueType>
